import { configureStore } from "@reduxjs/toolkit";
import React from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import "../src/modules/organization-setup/remove-dev-overlay/index"; // THIS MUST COME FIRST
import App from "./App";
import "./index.css";
import ErrorFallback from "./modules/organization-setup/error-fallback";
import reducer from "./store/reducer";

const root = ReactDOM.createRoot(document.getElementById("root"));
const store = configureStore({ reducer });
root.render(
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);
